<div class="container-fluid">
  <div class="row">
    <div class="herobg">
      <div class="vidcon">
        <div class="videocontainer">
          <div class="anim-cont">
            <div class="replay-button">
              <button type="button" (click)="playYouTubeVideo()">
                WATCH VIDEO
              </button>
            </div>
            <div class="tagline">WHERE EDUCATION<br>MEETS OPPORTUNITY</div>
            <div class="slide-border">
              <ul class="slides">
                <li class="slidelist">
                  <span class="slidetext">Credentials of Value</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Individualized Advising</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Seamless Transitions</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Work-Based Learning</span>
                </li>
              </ul>
            </div>
          </div>
          @if (showYouTube) {
          <iframe class="videoembed" src="https://www.youtube.com/embed/y-ufGpDdQug?autoplay=1&rel=0&controls=0"
            title="Future Ready TN Video" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          } @else {
            <video class="videoembed" autoplay muted playsinline>
              <source src="/FutureReady_Preview_Web_MX_1920.mp4" type="video/mp4" title="Future Ready TN Intro Video">
            </video>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- PAGE SUMMARY -->
    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title>
          <h1>Postsecondary, Workforce, CTE, and Military Readiness</h1>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          The Division of Postsecondary, Workforce, CTE, and Military Readiness is committed to ensuring all students
          graduate high school prepared for success. By prioritizing four key pillars—Credentials of Value, Seamless
          Transitions, Individualized Advising, and Work-Based Learning— students will be equipped with the knowledge,
          skills, and experiences needed to thrive in an evolving economy. Through aligned credentials, clear pathways
          to postsecondary education, personalized advising, and hands-on career experiences, the high school experience
          is being transformed to ensure every student can pursue a meaningful and rewarding future. The goals and
          programs associated with each of these pillars not only strengthen workforce readiness but also support
          Tennessee’s economic growth by bridging education and industry needs. Explore each pillar below to learn how
          the Division of Postsecondary, Workforce, CTE, and Military Readiness is building a future-ready Tennessee.
        </p>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row">
    <!-- PILLARS -->
    <div class="flex-container">
      <div class="outer-pillar-div-one" onclick="window.location.replace(window.location.href = '/pillar-1')">
        <img src="CredentialsofValue.png" class="card-img-top" alt="Credentials of Value Image">
        <div class="inner-pillar">
          <h2>Credentials of Value</h2>
          <p>Tennessee is dedicated to transforming the high school experience by providing students with access to
            high-quality postsecondary credentials that foster academic success and workforce readiness. By aligning
            secondary and postsecondary credentials with labor market demands, students seamlessly transition into
            in-demand careers.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Tennessee Student Industry Credentials of Value</li>
            </ul>
        </div>
      </div>
      <div class="outer-pillar-div-two" onclick="window.location.replace(window.location.href = '/pillar-3')">
        <img src="IndividualizedAdvising.png" class="card-img-top" alt="Individualized Advising Image">
        <div class="inner-pillar">
          <h2>Individualized Advising</h2>
          <p>Tennessee is establishing a career coach network to improve individualized advising for students. By
            exploring opportunities to increase the capacity of career coaches and advising professionals students will
            be able to make informed decisions regarding their future career options. Career coaches and advising
            professionals will gain the tools needed to increase high-quality advising so students can transition
            successfully after high school graduation.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Career & Technical Student Organizations (CTSO)</li>
              <li class="pillar-bullet">Career Coaches</li>
              <li class="pillar-bullet">CTE Career Clusters & Standards</li>
              <li class="pillar-bullet">Graduation Requirements</li>
              <li class="pillar-bullet">Military Readiness</li>
            </ul>
        </div>
      </div>
      <div class="outer-pillar-div-three" onclick="window.location.replace(window.location.href = '/pillar-2')">
        <img src="SeamlessTransitions.png" class="card-img-top" alt="Seamless Transitions Image">
        <div class="inner-pillar">
          <h2>Seamless Transitions</h2>
          <p>Tennessee prioritizes seamless transitions from high school to postsecondary education by aligning K-12 and
            higher education systems. This effort includes highlighting dual enrollment best practices, fostering
            partnerships with higher education stakeholders, and promoting transparency and equity. These initiatives
            ensure clear pathways to postsecondary success, supporting the state’s long-term workforce development
            goals.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Accountability and Data Reporting</li>
              <li class="pillar-bullet">Computer Science (CS)</li>
              <li class="pillar-bullet">Early Postsecondary Opportunities (EPSO)</li>
              <li class="pillar-bullet">Innovative School Strategies</li>
              <li class="pillar-bullet">Licensure and Training Attendance Records</li>
              <li class="pillar-bullet">Science, Technology, Engineering, Arts, and Mathematics STE(A)M</li>
            </ul>
        </div>
      </div>
      <div class="outer-pillar-div-four" onclick="window.location.replace(window.location.href = '/pillar-4')">
        <img src="Work-BasedLearning.png" class="card-img-top" alt="Work-Based Learning Image">
        <div class="inner-pillar">
          <h2>Work-Based Learning</h2>
          <p>Tennessee is dedicated to ensuring all students understand how high-quality curriculum and instruction
            allow them to pursue fulfilling careers in high-growth, in-demand, and high-wage industry sectors through
            capstone Work-Based Learning (WBL) experiences. The application of academic and technical knowledge in a
            work setting that involves actual work experience is a critical component of workforce readiness. The
            resources under this Pillar allow all stakeholders to utilize the WBL Framework and offer immersive
            experiences where students leverage their interests and aptitudes to accelerate their careers based on labor
            market needs and available employment opportunities.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Work-Based Learning</li>
            </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- NEW QUICK FACTS -->
  <div class="row">
    <div class="flexcontainer">
      <div class="qf-container">
        <div data-module="countup">
          <div class="colspacing">
            <div class="container wide">
              <div class="row">
                <div class="col-12 col-md-12 light text-center p-3">
                  <h1 class="qf-title">QUICK FACTS</h1>
                  <div class="colored_hr col-12 mx-auto d-block"></div>
                  <div class="stats">
                    <div class="stat">
                      <div class="stat-figure">
                        <div class="value">
                          <span class="text-reverse" [countUp]="industryCredentials" [countUpOptions]="indCred">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix quick-facts">
                    <img src="Credentials_01_white-t.png" alt="Credentials Image">
                    <p class="qfclearfix">In 2024-25, 77,455 industry credentials were earned by secondary students
                      statewide.</p>
                  </div>

                  <div class="colored_hr col-12 mx-auto d-block"></div>
                  <div class="stats">
                    <div class="stat">
                      <div class="stat-figure">
                        <div class="value">
                          <span class="text-reverse" [countUp]="studentsEpso" [countUpOptions]="stuEpso">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix quick-facts">
                      <img src="EPSO_02_white-t.png" alt="Early Postsecondary Opportunities Image">
                      <p class="qfclearfix">Students in EPSOs are up to 88% more likely to pursue postsecondary
                        education after high school graduation.</p>
                    </div>

                    <div class="colored_hr col-12 mx-auto d-block"></div>
                    <div class="stats">
                      <div class="stat">
                        <div class="stat-figure">
                          <div class="value">
                            <span class="text-reverse" [countUp]="personalizedAdvising"
                              [countUpOptions]="persAdv">0</span>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix quick-facts">
                        <img src="PersonalizedAdvising_03_white-t.png" alt="Personalized Advising Image">
                        <p class="qfclearfix">Students who receive personalized advising are 2x more likely to develop a
                          clear postsecondary plan.</p>
                      </div>

                      <div class="colored_hr col-12 mx-auto d-block"></div>
                      <div class="stats">
                        <div class="stat">
                          <div class="stat-figure">
                            <div class="value">
                              <span class="text-reverse" [countUp]="wblStudents" [countUpOptions]="wblStu">0</span>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix quick-facts">
                          <img src="quick-facts-4-t.png" alt="Work-based Learning Image">
                          <p class="qfclearfix">WBL students are nearly 25% more likely to enroll in postsecondary than
                            non WBL students seamlessly after high school.</p>
                        </div>

                        <div class="colored_hr col-12 mx-auto d-block"></div>
                        <div class="stats">
                          <div class="stat">
                            <div class="stat-figure">
                              <div class="value">
                                <span class="text-reverse" [countUp]="moreAverage" [countUpOptions]="morAvg">0</span>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix quick-facts">
                            <img src="dollar-signs.png" alt="More Money Postsecondary Degree Image">
                            <p class="qfclearfix">WBL students earn nearly $4,200 more on average per year without a
                              postsecondary degree than non-WBL students without a postsecondary degree eight years
                              after high school graduation.</p>
                          </div>
                          <div class="colored_hr col-12 mx-auto d-block"></div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row row-gallery">
            <app-rotating-gallery />
          </div>

          <div class="row">
            <div class="image-container">
              <h2 class="carousel-header-from-students">FROM OUR STUDENTS...</h2>
              <div role="region" id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel"
                aria-roledescription="Carousel" aria-label="Student Testimonials">
                <div class="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1" data-name="1"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3"
                    aria-label="Slide 4"></button>
                </div>
                <div class="carousel-inner">
                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark"
                    data-bs-slide="prev" aria-label="Previous Slide">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>

                  <div class="carousel-item active maroon" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>I got certified as a medical assistant, along with getting my
                          BLS certification, which is CPR, before graduating high school. I learned so much that most
                          people don’t get to experience until they’re halfway through college...</p>
                        <h2>NOAH LAND</h2>
                        <p>2025 Graduate<br>Polk County High School<br>Polk County Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item silver" data-bs-interval="4000">
                    <div class="carousel-caption d-block dark">
                      <div class="inner-caro-text">
                        <p>It’s truly incredible—the program of work-based learning in
                          itself, allowing kids to get out into the workforce during the school day, allowing them to
                          search for their future career and get real world experiences...</p>
                        <h2>KATELYN WILLIAMS</h2>
                        <p>2025 Graduate<br>Liberty Creek High School<br>Sumner County Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item blue" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>This could be what I want to do in my future and with my life...
                          The school has helped me towards the goal of going to the airlines and becoming a professional
                          pilot in a lot of different ways...</p>
                        <h2>ANDREW RODABAUGH</h2>
                        <p>Senior<br>Oak Ridge High School<br>Oak Ridge Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item grey" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>I am very grateful to have had the opportunity to earn my Private
                          Pilot's License... This is my senior year at Alcoa High School, and through my aviation
                          program of study, I am now able to participate in a workbased learning internship with Cirrus
                          Aircraft...</p>
                        <h2>LEVI SPIVEY</h2>
                        <p>Senior<br>Alcoa High School<br>Alcoa City Schools</p>
                      </div>
                    </div>
                  </div>
                </div>

                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark"
                  data-bs-slide="next" aria-label="Next Slide">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>